(function(){
  window.__lioiSmartSearchLoaded = true;
  window.__lioiSmartSearchDisabled = true;

  function restoreNativeSearch() {
    document.documentElement.classList.remove("lioi-legacy-search-disabled");
    document.querySelectorAll(".lioi-smart-search-header-button,#lioi-smart-search-modal,#lioi-smart-search-global-style").forEach(function(node) {
      node.remove();
    });
    document.querySelectorAll(".lioi-native-search-hidden").forEach(function(node) {
      node.classList.remove("lioi-native-search-hidden");
      node.removeAttribute("aria-hidden");
    });
    document.querySelectorAll("header [tabindex='-1'],.shopify-section-header [tabindex='-1']").forEach(function(node) {
      var text = [
        node.getAttribute("aria-label"),
        node.getAttribute("title"),
        node.className
      ].join(" ");
      if (/search|buscar|header__icon--search|site-header__search-toggle/i.test(text)) {
        node.removeAttribute("tabindex");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreNativeSearch, { once: true });
  } else {
    restoreNativeSearch();
  }
})();